import video from '../assets/heroVideo2.mp4';
// import videoPoster from "https://images.unsplash.com/photo-1516450360452-9312f5e86fc7?w=600&h=800&fit=crop";

export const blurb4Config  = {

      heading: "Previous Events",
      paragraph: "Over the years, we've hosted countless memorable events that have become part of Las Vegas entertainment history. Here are some highlights from our journey:",
      events: [
        "Nellis AFB Comedy Night",
        "Slaughter Comedy Showdown",
        "Birthday Bash",
        "Summer Comedy Jam",
        "Summer Comedy Jam",
        "Open Mic Nights"
      ],
      buttonText: "See All Events",
      videoUrl: video,
      videoPoster: '../assets/heroImage1.jpg'


};